import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HomeService } from './../../services/home.service' ;
import { HttpService } from './../../services/http.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CacheService } from 'src/app/services/cache.service';
import { AppConfig } from 'src/app/app.config';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  
  service_count: any;
  countService : string ='';
  countContract: string ='';
  currentLang: string ="en";
  username: any;
  public dmbrapplog: string | undefined;
  public dmbrwsmtlog: string | undefined;
  public v360applog: string | undefined;
  public v360wsmtlog: string | undefined;
 
  
  constructor(private homeService: HomeService,
    private toastrService: ToastrService, 
    private router: Router, 
    public translate: TranslateService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer ,
    private apiconfig :AppConfig,
    private cacheService: CacheService) { 
    iconRegistry.addSvgIcon('power_settings', sanitizer.bypassSecurityTrustResourceUrl('./../../assets/icons/power_settings.svg'));

  }

 

  ngOnInit() {
    this.username=this.cacheService.getItem('username');
    if (this.cacheService.getItem('locale') && (this.cacheService.getItem('locale') != null || this.cacheService.getItem('locale') != 'null')) {
      console.log(localStorage.getItem('locale'));
      const browserLang = this.cacheService.getItem('locale');
      this.translate.use(browserLang);
      this.currentLang=this.translate.currentLang;
    } else {
      this.translate.use('en');
      this.currentLang='en';
    }
    this.homeServiceC();
    this.homeContractC();
    this.dmbrapplog=this.apiconfig.dmbrapplog;
    this.dmbrwsmtlog=this.apiconfig.dmbrwsmtlog;
    this.v360applog=this.apiconfig.v360applog;
    this.v360wsmtlog=this.apiconfig.v360wsmtlog;
  }

  homeServiceC(){
    this.homeService.getServiceCount().subscribe(response => {
      if (response) {
        console.log('serice sount is '+ response.serviceCount);
       
        if (Object.keys(response.serviceCount).length !== 0 || response.serviceCount!=null && response.serviceCount!='') {
          //Assigning value to payerType recieved in response 
          this.countService = response.serviceCount;   
          //localStorage.setItem(localStorage.getItem('locale'));
      
  }}},
  error => {
    this.countService='';
    this.toastrService.warning(this.translate.instant('dmbr-bo.i18n.message.sericecount.notfound'), this.translate.instant('dmbr-bo.i18n.message.toastr.warning'),  {closeButton: true,});   
  })
}

changeLang(language: string) {  
  this.cacheService.setItem('locale', language);
  this.translate.use(language);  
} 


homeContractC(){
  this.homeService.getContractCount().subscribe(response => {
    if (response) {
      console.log('Contract sount is '+ response.contractCount);
      //this.service_count = response;
     
      if (Object.keys(response.contractCount).length !== 0 || response.contractCount!=null && response.contractCount!='') {
        //Assigning value to payerType recieved in response 
        this.countContract = response.contractCount;   
        ///localStorage.setItem(localStorage.getItem('locale'));
     // this.router.navigate(["home"]);
      //localStorage.setItem(localStorage.getItem('locale'));
}}},
error => {
  this.countContract='';
  this.toastrService.warning(this.translate.instant('dmbr-bo.i18n.message.contractcount.notfound'), this.translate.instant('dpo.i18n.message.toastr.warning'),  {closeButton: true,});   
 //this.router.navigate(["home"]);
})
}

logout() {
  this.cacheService.clear();
  this.router.navigate(["login"]);
}
}

//  changeLang(lang: string) { 
//    this.translate.use( localStorage.getItem('locale'));  
//  }
